import { HYDRATE } from 'next-redux-wrapper';

import * as ActionCreators from '~/src/features/specialOffersContainer/store/actions';
import { ESpecOfferActionTypes } from '~/src/features/specialOffersContainer/store/actions/constants';
import { TPopupState, TSpecOffer } from '~/src/features/specialOffersContainer/types';
import { InferValueTypes, THydrateAction } from '~/src/store';

export interface ISpecOfferStore {
    isLoading: boolean,
    offers: TSpecOffer[],
    selectedOfferId: TSpecOffer['requestId'],
    popupState: TPopupState,
    isPopupOpened: boolean,
    transaction: string | null,
    errorMessage: string | null,
}

const INITIAL_STATE: ISpecOfferStore = {
    isLoading: true,
    offers: [],
    selectedOfferId: 0,
    popupState: 'none',
    isPopupOpened: false,
    transaction: null,
    errorMessage: null,
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

const specOfferReducer = (state = INITIAL_STATE, action: TActions): ISpecOfferStore => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.specOffers };
        case ESpecOfferActionTypes.setIsLoading:
            return {
                ...state,
                isLoading: action.payload,
            };
        case ESpecOfferActionTypes.setOffers:
            return {
                ...state,
                offers: action.payload,
            };
        case ESpecOfferActionTypes.setSelectedOfferId:
            return {
                ...state,
                selectedOfferId: action.payload,
            };
        case ESpecOfferActionTypes.setIsPopupOpened:
            return {
                ...state,
                isPopupOpened: action.payload,
            };
        case ESpecOfferActionTypes.setPopupState:
            return {
                ...state,
                popupState: action.payload,
            };
        case ESpecOfferActionTypes.setOfferTransaction:
            return {
                ...state,
                transaction: action.payload,
            };
        case ESpecOfferActionTypes.setErrorMessage:
            return {
                ...state,
                errorMessage: action.payload,
            };
        default:
            return state;
    }
};

export default specOfferReducer;
